import { render, staticRenderFns } from "./ChangeEmailThanks.vue?vue&type=template&id=6feaff0e&"
import script from "./ChangeEmailThanks.vue?vue&type=script&lang=js&"
export * from "./ChangeEmailThanks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports